// extracted by mini-css-extract-plugin
module.exports = {"list-container":"Certification_list-container__3ylLN"};